import { chakra, Flex, FlexProps, HStack } from '@chakra-ui/react'
import { ConditionalValue } from '@chakra-ui/react'
import { motion } from 'motion/react'
import React from 'react'

interface LoadingDotsProps extends FlexProps {
  dotSize?: ConditionalValue<string>
  animationOptions?: {
    animationDuration: number
    xScaleMin: number
    xScaleMax: number
    yScaleMin: number
    yScaleMax: number
    startingOpacity: number
    opacityMin: number
    opacityMax: number
    dotDelayIncrement: number
  }
}

const AnimatedBox = chakra(motion.div)

export const LoadingDots = ({
  dotSize = '0.5rem',
  animationOptions = {
    animationDuration: 0.5,
    xScaleMin: 1,
    xScaleMax: 1,
    yScaleMin: 0.5,
    yScaleMax: 1.25,
    startingOpacity: 1,
    opacityMin: 1,
    opacityMax: 1,
    dotDelayIncrement: 0.5,
  },
  ...rest
}: LoadingDotsProps) => {
  const {
    animationDuration,
    xScaleMin,
    xScaleMax,
    yScaleMin,
    yScaleMax,
    startingOpacity,
    opacityMin,
    opacityMax,
    dotDelayIncrement,
  } = animationOptions

  const xScaleMid = (xScaleMin + xScaleMax) / 2
  const xScales = [xScaleMax, xScaleMid, xScaleMin]

  const yScaleMid = (yScaleMin + yScaleMax) / 2
  const yScales = [yScaleMax, yScaleMid, yScaleMin]

  const opacityMid = (opacityMin + opacityMax) / 2
  const opacities = [startingOpacity, opacityMax, opacityMid, opacityMin]

  const delays = [0, dotDelayIncrement, dotDelayIncrement * 2]
  return (
    <Flex
      alignItems="flex-end"
      height="inherit"
      width="fit-content"
      pb={`calc(50% - ${dotSize}/2)`}
      pr="2rem"
      {...rest}
    >
      <HStack
        width="fit-content"
        height="fit-content"
        alignContent="center"
        justifyContent="center"
      >
        <AnimatedBox
          width={dotSize}
          height={dotSize}
          borderRadius="50%"
          backgroundColor="border.default"
          animate={{
            opacity: opacities,
            scaleX: xScales,
            scaleY: yScales,
          }}
          transition={
            {
              duration: animationDuration,
              ease: 'easeInOut',
              repeat: Infinity,
              repeatType: 'reverse',
              delays: delays[0],
            } as any
          }
        />
        <AnimatedBox
          width={dotSize}
          height={dotSize}
          borderRadius="50%"
          backgroundColor="border.default"
          animate={{
            opacity: opacities,
            scaleX: xScales,
            scaleY: yScales,
          }}
          transition={
            {
              duration: animationDuration,
              ease: 'easeInOut',
              repeat: Infinity,
              repeatType: 'reverse',
              delay: delays[1],
            } as any
          }
        />
        <AnimatedBox
          width={dotSize}
          height={dotSize}
          borderRadius="50%"
          backgroundColor="border.default"
          animate={{
            opacity: opacities,
            scaleX: xScales,
            scaleY: yScales,
          }}
          transition={
            {
              duration: animationDuration,
              ease: 'easeInOut',
              repeat: Infinity,
              repeatType: 'reverse',
              delay: delays[2],
            } as any
          }
        />
      </HStack>
    </Flex>
  )
}
